<template>
  <div class="container">
    <content-template>
      <template slot="left"></template>
      <template slot="right">
        <!--<li>-->
          <!--<router-link to="huiye">線上報名</router-link>-->
        <!--</li>-->
        <!--<li> <router-link to="download">下載表格</router-link></li>-->
        <!--<li><a href="#" @click="getDirectorGeneral">簡介及比賽規章</a></li>-->
      </template>
      <template slot="content" id="text">
        <!--<div v-html="pageContent"></div>-->
        <div class="suc-title">投票成功</div>
        <div class="suc-content">多謝你的參與</div>
        <div class="suc-footer">
          <!--<button>完成</button>-->
          <button>返回</button>
        </div>
      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'

export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      pageContent: ''
    }
  },
  methods: {
    getPage: function (page) {
      var that = this
      var url = this.$url + 'portal/pages/' + page
      this.$axios.get(url)
        .then(function (response) {
          if (response.data.code === 1) {
            that.pageContent = response.data.data.post_content
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 理事长的话
    getDirectorGeneral: function () {
      this.getPage(4)
    },
    // 关于本站
    getIntroduct: function () {
      this.getPage(3)
    }
  },
  created () {
    this.getIntroduct()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }
  .suc-title{
    font-size: 24px;
    color: #565656;
    text-align: center;
  }
  .suc-content{
    font-size: 18px;
    color: #4A4A4A;
    letter-spacing: 0;
    text-align: center;
  }
  .suc-footer{
    text-align: center;
  }
  .suc-footer button{
    width: 180px;
    border: 2px solid #5571EC;
    border-radius: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/success.vue